<template>
  <v-dialog v-model="dialogo" :max-width="esImagen ? '800px' : '100%'" scrollable>
    <v-card>
      <v-card-title class="pt-2 pb-0"> Previsualización de archivo </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="py-0 px-0">
        <div>
          <v-img
            class="img-previsualizacion"
            v-if="previsualizacion && esImagen"
            :src="previsualizacion"
            aspect-ratio="1"
            contain></v-img>

          <iframe class="iframe-pdf" v-else-if="previsualizacion && esPdf" :src="previsualizacion"></iframe>

          <v-icon v-else>mdi-image-broken-variant</v-icon>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalPrevisualizacionAdjunto',
  data() {
    return {
      dialogo: false,
      previsualizacion: null,
      esImagen: false,
      esPdf: false,
    };
  },
  methods: {
    abrir(previsualizacion, esImagen, esPdf) {
      this.previsualizacion = previsualizacion;
      this.esImagen = esImagen;
      this.esPdf = esPdf;
      this.dialogo = true;
    },
    cerrar() {
      this.dialogo = false;
    },
  },
};
</script>

<style scoped>
.iframe-pdf {
  border: none;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}

.img-previsualizacion {
  width: 100%;
  height: calc(var(--vh, 1vh) * 100 - 16rem);
  background: #f0f0f0;
}

.img-previsualizacion .v-image__image {
  background-size: contain;
}
</style>